export default "__VITE_ASSET__B2hZQr1B__"